var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_895_17676",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_895_17676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4974 14.6665C3.9974 14.6665 3.56684 14.4971 3.20573 14.1582C2.84462 13.8193 2.66406 13.3999 2.66406 12.8999V3.59987C2.66406 3.17765 2.79462 2.79987 3.05573 2.46654C3.31684 2.1332 3.65851 1.92209 4.08073 1.8332L10.6641 0.533203V11.1999L4.3474 12.4665C4.2474 12.4888 4.16406 12.5415 4.0974 12.6249C4.03073 12.7082 3.9974 12.7999 3.9974 12.8999C3.9974 13.0221 4.0474 13.1249 4.1474 13.2082C4.2474 13.2915 4.36406 13.3332 4.4974 13.3332H11.9974V2.66654H13.3307V14.6665H4.4974ZM4.66406 11.0499L5.9974 10.7832V2.81654L4.66406 3.0832V11.0499Z",
    fill: "#FFDD00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.e9e0ef0de9a51c14a2cdad42a5b112ea.svg";
export { ForwardRef as ReactComponent };